import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// react-markdown v10 no longer passes an `inline` prop and passes `node` to every
// component — so we style block code via `pre` and keep `code` inline by default,
// and strip `node` before spreading onto DOM elements.
const components = {
  h1: ({ node, ...p }) => <h1 className="font-heading font-extrabold text-3xl mt-10 mb-4" {...p} />,
  h2: ({ node, ...p }) => <h2 className="font-heading font-bold text-2xl mt-9 mb-3" {...p} />,
  h3: ({ node, ...p }) => <h3 className="font-heading font-semibold text-xl mt-7 mb-2" {...p} />,
  p: ({ node, ...p }) => <p className="text-base leading-7 text-foreground/90 my-4" {...p} />,
  a: ({ node, ...p }) => <a className="text-primary underline underline-offset-2 hover:opacity-80" target="_blank" rel="noopener noreferrer" {...p} />,
  ul: ({ node, ...p }) => <ul className="list-disc pl-6 my-4 space-y-1.5 text-foreground/90" {...p} />,
  ol: ({ node, ...p }) => <ol className="list-decimal pl-6 my-4 space-y-1.5 text-foreground/90" {...p} />,
  li: ({ node, ...p }) => <li className="leading-7" {...p} />,
  blockquote: ({ node, ...p }) => <blockquote className="border-l-4 border-primary/50 pl-4 italic text-muted-foreground my-5" {...p} />,
  img: ({ node, ...p }) => <img className="rounded-xl my-6 w-full border border-border" loading="lazy" alt={p.alt || ""} {...p} />,
  pre: ({ node, ...p }) => <pre className="p-4 rounded-xl bg-muted overflow-x-auto my-5 text-sm" {...p} />,
  code: ({ node, className, ...p }) => /language-/.test(className || "")
    ? <code className={`font-mono text-sm ${className || ""}`} {...p} />
    : <code className="px-1.5 py-0.5 rounded bg-muted text-sm font-mono" {...p} />,
  hr: () => <hr className="my-8 border-border" />,
  table: ({ node, ...p }) => <div className="overflow-x-auto my-5"><table className="w-full text-sm border-collapse" {...p} /></div>,
  th: ({ node, ...p }) => <th className="border border-border px-3 py-2 text-left font-semibold bg-muted/50" {...p} />,
  td: ({ node, ...p }) => <td className="border border-border px-3 py-2" {...p} />,
};

export default function MarkdownView({ children }) {
  return (
    <div data-testid="markdown-body">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{children || ""}</ReactMarkdown>
    </div>
  );
}
